/* global ADV */

const chartSettings = {
    chart: {
        type: 'column',
    },
    title: {
        text: '',
    },
    legend: {
        enabled: false,
    },
    credits: {
        enabled: false,
    },
    exporting: {
        enabled: false,
    },
    xAxis: {
        categories: [],
        gridLineWidth: 0,
    },
    yAxis: {
        title: {
            text: '',
        },
        gridLineColor: '#ddd',
        gridLineDashStyle: 'Dot',
        gridLineWidth: 2,
        labels: {
            formatter() {
                return `$${ADV.util.short_number_format(this.value)}`;
            },
            style: {
                fontFamily: 'Open Sans, helvetica, sans-serif',
                fontSize: '13px',
                color: '#888',
            },
        },
    },
    series: [
        {
            name: 'Expenses',
            data: [],
            color: '#e5f8ff',
            fillOpacity: 1,
            borderColor: '#5abee4',
            borderWidth: 2,
        }, {
            name: 'Expenses Covered',
            color: '#5abee4',
            fillOpacity: 1,
            data: [],
        },
    ],
    tooltip: {
        useHTML: true,
        shadow: false,
        borderWidth: 0,
        backgroundColor: 'rgba(255,255,255,0)',
        borderRadius: 0,
        formatter() {
            return (
                `<div
                    class="education-chart-tooltip-container"
                >
                    <strong>
                        ${this.series.name}
                    </strong>
                    </br>
                    ${this.x} / $${ADV.util.number_format(this.y, 0)}
                </div>`
            );
        },
    },
    plotOptions: {
        column: {
            grouping: false,
            shadow: false,
            borderWidth: 0,
        },
    },
};

export default chartSettings;
